/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_UPLOAD_LOGS = gql`
  query GetTrackers($page: Int, $limit: Int) {
  getTrackers(page: $page, limit: $limit) {
    count
    content {
      logs {
        email
        txn_id
        job_result
        createdAt
        job_error
        job_parameters
        tracker_id
      }
      status
      createdAt
      fail
      name
      success
      total
      tracker_id
      updatedAt
    }
    limit
    page
  }
}
`;
